<script>
  import SettingsLayout from '../../components/SettingsLayout.svelte';
  import ApprovalStepToggle from '../../components/ApprovalStepToggle.svelte';
  import { user } from '../../stores/authStore.js';

  $: canEditApproval = !$user?.orgId || $user?.orgRole === 'owner' || $user?.orgRole === 'admin';
</script>

<SettingsLayout activeTab="approvals" tabTitle="Approvals" suppressManagedNotice={canEditApproval}>
  <ApprovalStepToggle />
</SettingsLayout>
